import type { GridPagination } from "@repo/ui";

export interface ComplaintsFilter extends GridPagination {
	// Date filters
	complaintDateAfter?: Date | null;
	complaintDateBefore?: Date | null;
	createdOnFrom?: Date | null;
	createdOnTo?: Date | null;
	enrollmentDateAfter?: Date | null;
	enrollmentDateBefore?: Date | null;

	// Text filters
	customerAccountNumber?: string;
	repId?: string;
	firstName?: string;
	lastName?: string;
	representativeFirstName?: string;
	representativeLastName?: string;
	esiId?: string;
	agentId?: string;
	customerName?: string;
	customerPhone?: string;
	complaintId?: string;

	// Dropdown filters
	status?: string;
	assignedStatus?: string;
	qaAnalystId?: number | null;
	sourceId?: number | null;
	reportingTagId?: number | null;
	/** Online Affiliates partner name, chosen from the selected brands' partners */
	affiliatePartnerName?: string | null;
	complaintOrIncident?: number | null;
	commissionComplaint?: boolean | null;
	commodity?: string;
	ope?: boolean | null;

	// Multi-select filters
	typeId?: number[];

	// Branch filters (from partial)
	branchIds?: number[];

	// Segment filters
	brands?: number[];
}

// Enums that match the MVC version
export enum RepIncidentStatus {
	Open = 0,
	Pending = 1,
	Complete = 2,
}

export enum RepIncidentAssignedStatus {
	Unassigned = 1,
	Assigned = 2,
	AssignedToMe = 3,
}

export enum CommodityTypeEnum {
	Electric = 0,
	Gas = 1,
	Both = 2,
}
